import { http } from './request';
import { DEMO_WORKSPACE_URLS } from './urls';
import type { EcommerceShopContext } from './ecommerceAccounts';

export type DataSpace = 'USER' | 'DEMO';
export type DemoScenario = 'self_operated' | 'buying';

export interface DemoWorkspace {
  enabled: boolean;
  active?: boolean;
  datasetId: string;
  scenario?: DemoScenario | string;
  displayName?: string;
  reason?: string;
  disabledFeatures: string[];
  demoComputePolicies?: Record<string, 'BLOCKED' | 'FREE' | 'CHARGE_REAL_USER' | string>;
  shop?: EcommerceShopContext;
  scenarios?: DemoScenarioOption[];
}

export interface DemoScenarioOption {
  scenario: DemoScenario | string;
  datasetId: string;
  displayName: string;
  enabled: boolean;
  shop?: EcommerceShopContext;
}

export function fetchDemoWorkspace(scenario?: string) {
  return http.get<DemoWorkspace>(DEMO_WORKSPACE_URLS.current, {
    params: scenario ? { scenario } : undefined,
  });
}
